module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/estrelas-03792aee616986eb4eefed043f787bfd.png";